import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';

const rows = [
  {
    id: 'amazonOrderId', disablePadding: true, label: 'Amazon Order',
  },
  {
    id: 'buyerName', disablePadding: false, label: 'Buyer Name',
  },
  {
    id: 'sku', disablePadding: false, label: 'SKU',
  },
  {
    id: 'productName', disablePadding: false, label: 'Product Name',
  },
  {
    id: 'quantityShipped', disablePadding: false, label: 'Quantity',
  },
  {
    id: 'itemPrice', disablePadding: false, label: 'Price',
  },
  {
    id: 'currency', disablePadding: false, label: 'Currency',
  },
  {
    id: 'shipAddress1', disablePadding: false, label: 'Address1',
  },
  {
    id: 'shipAddress2', disablePadding: false, label: 'Address2',
  },
  {
    id: 'shipCity', disablePadding: false, label: 'City',
  },
  {
    id: 'shipState', disablePadding: false, label: 'State',
  },
  {
    id: 'shipPostalCode', disablePadding: false, label: 'Postal Code',
  },
  {
    id: 'shipCountry', disablePadding: false, label: 'Country',
  },
  {
    id: 'salesChannel', disablePadding: false, label: 'Sales Channel',
  },
  {
    id: 'purchaseDate', disablePadding: false, label: 'Purchase Date',
  },  
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const MatTableHead = ({
  onSelectAllClick, order, orderBy, numSelected, rowCount, rtl, onRequestSort,
}) => (
  <TableHead>
    <TableRow>
      {/* <TableCell padding="checkbox">
        <Checkbox
          className={`material-table__checkbox ${numSelected === rowCount && 'material-table__checkbox--checked'}`}
          indeterminate={numSelected > 0 && numSelected < rowCount}
          checked={numSelected === rowCount}
          onChange={onSelectAllClick}
        />
      </TableCell> */}
      {rows.map(row => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-right"
          key={row.id}
          align={rtl.direction === 'rtl' ? 'right' : 'left'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
          width="10px"
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            {row.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

MatTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(MatTableHead);
